import { useState } from 'react'
import moment from 'moment'

export type Periodo = [moment.Moment, moment.Moment] | null

const CHAVE = 'painel.periodo'

// Default ao abrir sem nada salvo: ultimos 30 dias (30 dias atras -> hoje).
function periodoPadrao(): Periodo {
  return [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')]
}

function ler(): Periodo {
  try {
    const raw = localStorage.getItem(CHAVE)
    if (raw === null) return periodoPadrao() // 1a vez -> default 30 dias
    const v = JSON.parse(raw)
    if (!v) return null // usuario limpou o filtro de proposito
    const mi = moment(v[0])
    const mf = moment(v[1])
    return mi.isValid() && mf.isValid() ? [mi, mf] : periodoPadrao()
  } catch {
    return periodoPadrao()
  }
}

function salvar(p: Periodo) {
  try {
    localStorage.setItem(
      CHAVE,
      JSON.stringify(p ? [p[0].toISOString(), p[1].toISOString()] : null)
    )
  } catch {
    /* modo privado / storage bloqueado -> ignora */
  }
}

/**
 * Periodo do dashboard COMPARTILHADO entre as 4 telas (Vendas / Recebimentos / Extrato /
 * Conciliacao) via localStorage (mesma origem). Default = ultimos 30 dias na primeira abertura;
 * depois lembra a escolha do usuario. Trocar o periodo numa tela e navegar para outra leva o
 * mesmo periodo (cada tela le o localStorage ao montar).
 */
export function usePeriodoCompartilhado(): [Periodo, (p: Periodo) => void] {
  const [periodo, setPeriodoState] = useState<Periodo>(() => {
    const p = ler()
    // persiste o default ja na 1a vez, para as outras telas compartilharem imediatamente
    if (localStorage.getItem(CHAVE) === null) salvar(p)
    return p
  })

  const setPeriodo = (p: Periodo) => {
    setPeriodoState(p)
    salvar(p)
  }

  return [periodo, setPeriodo]
}
